export const MAX_BACKOFF_MS = 30_000;
export const HEARTBEAT_MS = 25_000;
export const RPC_TIMEOUT_MS = 30_000;
export const RPC_STREAM_TIMEOUT_MS = 300_000;
